/**
 * Shared cost validation for costed actions, used by both
 * the PAM SuggestedActionCard and the groups ActionModal.
 */

// Non-negative, finite, and within the backend's numeric column bound.
export const MAX_COST = 999999999999.99;

/**
 * Round a GBP amount to whole pence, half-up, matching the backend's
 * ROUND_HALF_UP quantisation of each component. Normalising the scaled value via
 * toFixed first cancels binary-float error (e.g. `1.005 * 100` is `100.4999…`,
 * which would otherwise round down and lose a penny) so the UI preview agrees
 * with the persisted total.
 */
export function roundToPence(amount: number): number {
  return Math.round(Number((amount * 100).toFixed(4))) / 100;
}

/** Validate a free-text cost input, returning an error message or undefined. */
export function validateCost(value: string): string | undefined {
  const trimmed = value.trim();
  if (trimmed === '') return undefined;

  const parsed = Number(trimmed.replaceAll(',', ''));
  if (!Number.isFinite(parsed)) return 'Enter a valid cost amount';
  if (parsed < 0) return 'Cost cannot be negative';
  if (parsed > MAX_COST) return 'Cost is too large';
  return undefined;
}
